module.exports = __webpack_public_path__ + "img/character-4.024bbfbe.webp";